"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mpsToKmh = void 0;
// convert meters per second to km per hour
const mpsToKmh = (mps) => {
    return `${Math.round(mps * 3.6)} km/h`;
};
exports.mpsToKmh = mpsToKmh;
